function sortFaces(A, B) {
  return A.map(f => f.code).join()
    .localeCompare(B.map(f => f.code).join());
}

function sortMateriel(A, B) {
  let numComparaison = A.code.localeCompare(B.code);
  if (numComparaison === 0 && A.faces && B.faces) {
    numComparaison = sortFaces(A.faces, B.faces);
  }
  return numComparaison;
}

function sortDispositif(A, B) {
  let numComparaison = A.code.localeCompare(B.code);
  if (numComparaison === 0 && A.materiels && B.materiels) {
    numComparaison = A.materiels.map(m => m.code).join()
      .localeCompare(B.materiels.map(m => m.code).join());
    if (numComparaison === 0) {
      const facesA = A.materiels.map(m => m.faces);
      const facesB = A.materiels.map(m => m.faces);
      if (facesA && facesB) numComparaison = sortFaces(facesA, facesB);
    }
  }
  return numComparaison;
}

export default function sort(listeDispositif) {
  listeDispositif.forEach(dispositif => {
    dispositif.materiels.forEach(materiel => {
      materiel.faces.sort((a, b) => {
        return a.code.localeCompare(b.code);
      });
    });
    dispositif.materiels.sort(sortMateriel);
  });
  listeDispositif.sort(sortDispositif);
}
